import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  font-size: 16px;
  padding: 20px;
  text-align: justify;
  @media screen and (min-width: 576px) {
    font-size: 20px;
  }
  height:100vh;
  overflow:hidden auto;
`;

const Privacy = () => {
  return (
    <StyledDiv>
      <p>
        This is the Privacy Policy of the <a href="http://itsutra.com/" target="_blank">www.itsutra.com</a> website (and any
        successor or other domains that we operate) and all content, services
        and products, including our mobile applications, that we provide
        (collectively, the “Application”). The Application is owned and operated
        by ITsutra Inc. (together with our affiliates and subsidiaries,
        “ITsutra”, “we”, “us”, “our” and terms of similar meaning). It describes
        the personal information that we collect from users of our Application
        as part of the normal operation of our Application, and how we use and
        disclose this information
      </p>
      <p>
        In this Privacy Policy, when we refer to “Users”, we mean our customers
        who use our Services to create their own Portfolios, and when we refer
        to “End Users” we mean the users, visitors and customers of our Users'
        Portfolios.
      </p>
      <p>
        This Privacy Policy describes what we do with personal information that
        we collect and use for our own purposes (i.e., where we are a
        controller), such as User Account information and information about how
        you use and interact with our Services, including information you submit
        to our customer support as well as certain information relating to our
        Users' End Users.
      </p>
      <p>
        Complete details on each type of Personal Data collected are provided in
        the dedicated sections of this privacy policy or by specific explanation
        texts displayed prior to the Data collection. The Personal Data
        collected may be freely provided by the User, or, in case of Usage Data,
        collected automatically when using our Application.
      </p>
      <p>
        All Data requested by this Application is mandatory and failure to
        provide this Data may make it impossible for this Application to provide
        its services. In cases where this Application specifically states that
        some Data is not mandatory, Users are free not to communicate this Data
        without any consequences on the availability or the functioning of the
        service. Users who are uncertain about which Personal Data is mandatory
        are welcome to contact the Owner
      </p>
      <p>
        Any use of Cookies - or of other tracking tools - by this Application or
        by the owners of third-party services used by this Application serves
        the purpose of providing the service required by the User, in addition
        to any other purposes described in the present document and in the
        Cookie Policy, if available. Users are responsible for any third-party
        Personal Data obtained, published or shared through this Application and
        confirm that they have the third party's consent to provide the Data to
        the Owner.
      </p>
      <h3>Information about this privacy policy</h3>
      <p>
        <span>
          The <b>Data Controller</b> is responsible for this privacy policy,
          prepared starting from the modules provided by ITsutra Inc. and hosted
          on <span>ITsutra's</span>
          servers. The following definitions apply solely to this Data Usage
          Policy:
        </span>
      </p>
      <h3>Personal Data (or Data)</h3>
      <p>
        <span>
          Any information regarding a natural person, a legal person, an
          institution or an association, which is, or can be, identified, even
          indirectly, by reference to any other information, including a
          personal identification number.
        </span>
      </p>
      <h3>Usage Data</h3>

      <p>
        <span>
          Information collected automatically from this Application (or third
          party services employed in this Application), which can include: the
          IP addresses or domain names of the computers utilized by the Users
          who use this Application, the URI addresses (Uniform Resource
          Identifier), the time of the request, the method utilized to submit
          the request to the server, the size of the file received in response,
          the numerical code indicating the status of the server's answer
          (successful outcome, error, etc.), the country of origin, the features
          of the browser and the operating system utilized by the User, the
          various time details per visit (e.g., the time spent on each page
          within the Application) and the details about the path followed within
          the Application with special reference to the sequence of pages
          visited, and other parameters about the device operating system and/or
          the User's IT environment.
        </span>
      </p>
      <h3>User</h3>
      <p>
        <span>
          The individual using this Application, which must coincide with or be
          authorized by the Data Subject, to whom the Personal Data refers.
        </span>
      </p>
      <h3>Data Subject</h3>
      <p>
        <span>
          The legal or natural person to whom the Personal Data refers.
        </span>
      </p>

      <h3>Data Processor (or Data Supervisor)</h3>

      <p>
        <span>
          The natural person, legal person, public administration or any other
          body, association or organization authorized by the Data Controller to
          process the Personal Data in compliance with this privacy policy.
        </span>
      </p>

      <h3>Data Controller (or Owner)</h3>

      <p>
        <span>
          The natural person, legal person, public administration or any other
          body, association or organization with the right, also jointly with
          another Data Controller, to make decisions regarding the purposes, and
          the methods of processing of Personal Data and the means used,
          including the security measures concerning the operation and use of
          this Application. The Data Controller, unless otherwise specified, is
          the Owner of this Application.
        </span>
      </p>

      <h3>THE USE OF THE COLLECTED DATA</h3>

      <p>
        <span>
          We use personal information in the file we maintain about you, and
          other information we obtain from your current and past activities on
          the Application, to provide to you the services offered by the
          Application; resolve service disputes; troubleshoot problems; measure
          consumer interest in our products and services; inform you about
          online and offline offers, products, services, events and updates;
          deliver information to you that, in some cases, is relevant to your
          interests, such as product news; customize your experience; detect and
          protect us against error, fraud and other criminal activity; enforce
          our Terms of Service; provide you with system or administrative
          messages, and as otherwise described to you at the time of collection.
        </span>
      </p>

      <p>
        <span>
          We may also use personal information about you to improve our
          marketing and promotional efforts, to analyze Application usage, to
          improve our content and product offerings, and to customize the
          Application's content, layout, and services. These uses improve the
          Application and better tailor it to meet your needs, so as to provide
          you with a smooth, efficient, safe and customized experience while
          using the Application.
        </span>
      </p>

      <h3>System logs and maintenance</h3>

      <p>
        <span>
          For operation and maintenance purposes, this Application and any{" "}
          <span>third party</span> services may collect files that record
          interaction with this Application (System logs) or use for this
          purpose other Personal Data (such as IP Address).
        </span>
      </p>

      <h3>Anonymized Aggregated Data</h3>

      <p>
        <span>
          We aggregate and anonymize data and use and disclose such information
          for a variety of purposes. However, in these situations, we do not
          disclose any information that could be used to identify you
          personally.
        </span>
      </p>

      <h3>End Users</h3>

      <p>
        <span>
          We may share with our Users data regarding usage by End Users of their
          Portfolios. For example, we may provide a User with information about
          what web page the End User visited before coming to their Portfolios
          and how their End Users interacted with their Portfolios. This is so
          Users can analyze the usage of their Portfolios and improve their
          services.
        </span>
      </p>

      <h3>Public Areas of the Application</h3>

      <p>
        <span>
          All of your activities in the public areas of the Application will be
          identifiable to your User ID, and other people can see your published
          content.
        </span>
      </p>

      <h3>Subsidiaries and Affiliates; Service Providers</h3>

      <p>
        <span>
          We may from time to time use the services of affiliates, subsidiaries
          and unrelated service providers in the operation of the Application,
          and may disclose personal information to them in the course of our use
          of their services. For example, we may use the services of third-party
          hosting companies to host the operation of the Application. This may
          involve the hosting of data, including personal information, on
          servers operated by those hosting companies. We also partner with
          third party publishers, advertising networks and service providers to
          manage our ads on other sites. Our <span>third party</span>
          partners may set cookies on your device or browser to gather
          information about your activities on the Services and other sites you
          visit, in order to provide you with <span>ITSutra</span> Inc. ads. For
          example, if you visit <span>ITSutra</span> Inc. and also use a social
          media platform, you may see an <span>ITSutra</span> Inc. ad in your
          social media newsfeed or timeline. See our Cookie Policy for more
          information. We take care to use only service providers that we
          believe are reputable and able to live up to our and your
          expectations, including the handling of confidential information.
        </span>
      </p>

      <h3>Legal Requests; Emergencies; Jurisdictions</h3>

      <p>
        <span>
          We cooperate with law enforcement inquiries and demands for
          information that are made under force of law. We are also cognizant of
          the need to address emergencies. Therefore, we may disclose User and
          End User personal information (a) to any governmental authority as
          part of an investigation to determine our compliance with any
          applicable law, rule, or regulation (including privacy laws, rules,
          and regulations), (b) in response to a court order, subpoena,
          discovery request, or other lawful judicial or administrative
          proceeding, (c) as otherwise required under any applicable law, rule,
          or regulation, and (d) in good faith, to protect or defend our rights
          or property or those of other users or End Users.
        </span>
      </p>

      <p>
        <span>
          We may also disclose personal information to the acquiror or its
          agents in the course of the sale of our business. If we do this, the
          disclosure will be subject to confidentiality arrangements customary
          in such transactions.
        </span>
      </p>

      <h3>Third party applications</h3>

      <p>
        <span>
          <span>Facebook:</span>
        </span>
        <span>
          This Application may ask for some Facebook permissions allowing it to
          perform actions with the User's Facebook account and to retrieve
          information, including Personal Data, from it. This service allows
          this Application to connect with the User's account on the Facebook
          social network, provided by Facebook Inc.
        </span>
      </p>

      <p>
        <span>
          For more information about the following permissions, refer to
          the&nbsp;
        </span>
        <a
          href="https://developers.facebook.com/docs/authentication/permissions/"
          target="_blank"
        >
          <span>Facebook permissions documentation</span>
        </a>
        <span>&nbsp;and to the&nbsp;</span>
        <a href="https://www.facebook.com/about/privacy/" target="_blank">
          <span>Facebook privacy policy</span>
        </a>
        <span>.</span>
      </p>

      <p>
        <span>The permissions asked are the following:</span>
      </p>

      <p>
        <span>
          By default, this includes certain User’s Data such as id, name,
          picture, gender, and their locale. Certain connections of the User,
          such as the Friends, are also available. If the User has made more of
          their Data public, more information will be available.
        </span>
      </p>

      <h3>MODE AND PLACE OF PROCESSING THE DATA</h3>

      <h3>Methods of processing</h3>

      <p>
        <span>
          The Data Controller processes the Data of Users in a proper manner and
          shall take appropriate security measures to prevent unauthorized
          access, disclosure, modification, or unauthorized destruction of the
          Data. The Data processing is carried out using computers and/or IT
          enabled tools, following organizational procedures and modes strictly
          related to the purposes indicated. In addition to the Data Controller,
          in some cases, the Data may be accessible to certain types of persons
          in charge, involved with the operation of the site (administration,
          sales, marketing, legal, system administration) or external parties
          (such as third party technical service providers, mail carriers,
          hosting providers, IT companies, communications agencies) appointed,
          if necessary, as Data Processors by the Owner. The updated list of
          these parties may be requested from the Data Controller at any time.
        </span>
      </p>

      <h3>Place</h3>

      <p>
        <span>
          The Data is processed at the Data Controller's operating offices and
          in any other places where the parties involved with the processing are
          located. For further information, please contact the Data Controller.
        </span>
      </p>

      <h3>Retention time</h3>

      <p>
        <span>
          The Data is kept for the time necessary to provide the service
          requested by the User, or stated by the purposes outlined in this
          document, and the User can always request that the Data Controller
          suspend or remove the data.
        </span>
      </p>

      <h4>Information not contained in this policy</h4>

      <p>
        <span>
          More details concerning the collection or processing of Personal Data
          may be requested from the Data Controller at any time. Please see the
          contact information available at our website to reach the Data
          Controller.
        </span>
      </p>

      <h3>The rights of Users</h3>

      <p>
        <span>
          Users have the right, at any time, to know whether their Personal Data
          has been stored and can consult the Data Controller to learn about
          their contents and origin, to verify their accuracy or to ask for them
          to be supplemented, cancelled, updated or corrected, or for their
          transformation into anonymous format or to block any data held in
          violation of the law, as well as to oppose their treatment for any and
          all legitimate reasons. Requests should be sent to the Data Controller
          at the contact information set out above.
        </span>
      </p>

      <p>
        <span>
          This Application does not support “Do Not Track” requests. To
          determine whether any of the <span>third party</span> services it uses
          honor the “Do Not Track” requests, please read their privacy policies.
        </span>
      </p>

      <h3>Changes to this privacy policy</h3>

      <p>
        <span>
          The Data Controller reserves the right to make changes to this privacy
          policy at any time by giving notice to its Users on this page. It is
          strongly recommended to check this page often, referring to the date
          of the last modification listed at the bottom. If a User objects to
          any of the changes to the Policy, the User must cease using this
          Application and can request that the Data Controller remove the
          Personal Data. Unless stated otherwise, the then-current privacy
          policy applies to all Personal Data the Data Controller has about
          Users.
        </span>
      </p>
    </StyledDiv>
  );
};

export default Privacy;
